import { BrowserRouter, Switch, Route } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import CreateListing from "./pages/CreateListing";
import AdminListings from "./admin/AdminListings";
import MyListings from "./pages/MyListings";
import Messages from "./pages/Messages";
import MyMessages from "./pages/MyMessages";

import "./styles/main.css";

function App() {
  return (
    <BrowserRouter>

      <Switch>

        <Route
          exact
          path="/"
          component={Home}
        />

        <Route
          exact
          path="/login"
          component={Login}
        />

        <Route
          exact
          path="/register"
          component={Register}
        />

        <Route
          exact
          path="/products"
          component={Products}
        />

        <Route
          path="/products/:id"
          component={ProductDetails}
        />

        <Route
          path="/create-listing"
          component={CreateListing}
        />

        <Route
          path="/admin/listings"
          component={AdminListings}
        />

        <Route
          path="/my-listings"
          component={MyListings}
        />

        <Route
          path="/messages/:userId"
          component={Messages}
        />

        <Route
  path="/my-messages"
  component={MyMessages}
/>
      </Switch>

    </BrowserRouter>
  );
}

export default App;